import { Link } from "react-router-dom";
import Reveal from "../components/Reveal";

export default function About() {
  return (
    <>
      <section className="container-prose pt-16 sm:pt-24 pb-10">
        <Reveal>
          <span className="pill pill-lav">Our mission</span>
          <h1 className="mt-5 font-display text-5xl sm:text-6xl leading-[1.02] text-balance">
            Sanctuary, dignity, care — <em className="not-italic grad-text">without asking anyone for anything.</em>
          </h1>
          <p className="mt-6 text-lg text-ink-500 leading-relaxed">
            Sanctology Welfare Foundation exists to offer shelter and belonging
            to people who have been pushed to the edges: homeless elders with
            no family, and children with no parents or guardians. We meet
            people where they are and carry them into a home.
          </p>
        </Reveal>
      </section>

      <section className="container-prose py-10">
        <div className="grid gap-5 sm:grid-cols-2">
          <Reveal>
            <div className="surface h-full">
              <h3 className="font-display text-2xl">Our values</h3>
              <ul className="mt-4 space-y-3 text-ink-700 text-sm leading-relaxed">
                <li><strong className="text-ink-900">Dignity first.</strong> Nobody we serve is a beneficiary statistic. They are residents of our home.</li>
                <li><strong className="text-ink-900">No asking.</strong> We do not run donation campaigns. The people we serve are never asked to pay.</li>
                <li><strong className="text-ink-900">Quiet work.</strong> We measure success in meals shared and nights of sleep, not press coverage.</li>
                <li><strong className="text-ink-900">Local roots.</strong> We start where we are — Tirunelveli — and build outward as capacity allows.</li>
              </ul>
            </div>
          </Reveal>
          <Reveal delay={100}>
            <div className="surface h-full">
              <h3 className="font-display text-2xl">What we do</h3>
              <ul className="mt-4 space-y-3 text-ink-700 text-sm leading-relaxed">
                <li><strong className="text-ink-900">Elder Sanctuary.</strong> A residential home for older people with no family, offering food, medicine, companionship, and end-of-life dignity.</li>
                <li><strong className="text-ink-900">Orphan Sanctuary.</strong> A safe, schooled, loved home for children without guardians.</li>
                <li><strong className="text-ink-900">Volunteer network.</strong> Doctors, teachers, cooks, drivers, and neighbours who give their time.</li>
              </ul>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="container-prose py-14">
        <Reveal>
          <div className="glass-strong rounded-3xl p-8 sm:p-12 relative overflow-hidden">
            <div
              aria-hidden
              className="absolute -top-16 -right-16 h-64 w-64 rounded-full blur-3xl opacity-40"
              style={{ background: "radial-gradient(closest-side, #93ddd9, transparent)" }}
            />
            <span className="pill pill-teal">Who we are</span>
            <h2 className="mt-4 font-display text-4xl sm:text-5xl">
              The CSR arm of Logy Holdings
            </h2>
            <p className="mt-5 text-ink-700 leading-relaxed text-lg">
              Sanctology is a Section 8 not-for-profit company and the CSR arm
              of <strong>Logy Holdings</strong>. It is sustained entirely by
              profits from our sibling operating companies — Chaosology,
              Boreology, and Lectureology — which means we can keep our promise
              to never ask the people we serve, nor the public, for money.
            </p>
            <Link to="/support" className="btn-ghost mt-6">
              How we're funded →
            </Link>
          </div>
        </Reveal>
      </section>

      <section className="container-prose pb-20">
        <Reveal>
          <div className="surface">
            <h2 className="font-display text-3xl">Where we work</h2>
            <p className="mt-3 text-ink-700 leading-relaxed">
              Our home and registered office is in Tirunelveli, Tamil Nadu.
              India's southern tip has a quietly large population of elders
              living alone and children without guardians — and very little
              infrastructure built for them. We begin here.
            </p>
            <address className="not-italic mt-6 text-ink-700 leading-relaxed">
              <strong className="text-ink-900">Sanctology Welfare Foundation</strong><br />
              3/5, Panchayat Board St, Karuthapillaiyur<br />
              Tirunelveli, Tamil Nadu 627418<br />
              India
            </address>
          </div>
        </Reveal>
      </section>
    </>
  );
}
